import { jsx as _jsx } from "react/jsx-runtime";
import { WithdrawModal } from '../WithdrawModal/WithdrawModal';
export const withdrawModalConfig = (param)=>{
    let { relationshipId, draftId, onSuccess, openedBy = 'proposals-dashboard' } = param;
    return {
        biName: 'withdraw_modal',
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(WithdrawModal, {
                openedBy: openedBy,
                relationshipId: relationshipId,
                draftId: draftId,
                onSuccess: onSuccess,
                dismissModal: dismissModal
            });
        }
    };
};
